import {connect} from 'react-redux';
import {push} from 'connected-react-router'
import {eligibilityConfirmationSelect} from '../../redux/selector/eligibilityConfirmationSelector'
import {setEligibleToCollectDept} from '../../redux/slice/eligibilityConfirmationSlice'
import {
    Header, 
    Paragraph, 
    Button
} from '../../components/RegularComponents'
import {replaceUrlParams} from '../../app/utils'
import Navigation from '../Navigation';

function EligibilityConfirmation (props) { 
    let {eligibilityConfirmation} = props
    const{applicationType, applicationMode} = props.match.params

    if(eligibilityConfirmation[applicationType]){
        eligibilityConfirmation = eligibilityConfirmation[applicationType]
    }

    return (
        <>
            <Navigation {...props} />
            <div className={"container"}>
            <div className="row">
                <div className="col-lg-8">
                    <Header 
                        id="elibility-confirmation-header"
                        header={eligibilityConfirmation.header}/>
                    <Paragraph 
                        id="elibility-confirmation-text"
                        text={eligibilityConfirmation.text} />
                </div>
            </div>
            <div className="row">
                <div className="col-auto">
                    <Button 
                        id="eligble-to-collect-dept-yes"
                        className="ns-btn-yes-no btn-default"
                        onClick={() => {
                            props.dispatch(setEligibleToCollectDept(true))
                            props.dispatch(push(replaceUrlParams(eligibilityConfirmation.navigation.next,applicationType,applicationMode)))
                        }}
                        buttonType={"regular_primary"}
                        text={"Yes"}
                    />
                </div>
                <div className="col-auto">
                    <Button 
                        id="eligble-to-collect-dept-no"
                        className="ns-btn-yes-no btn-default"
                        onClick={() => { 
                            props.dispatch(setEligibleToCollectDept(false))
                            props.dispatch(push(replaceUrlParams(eligibilityConfirmation.navigation.previous,applicationType,applicationMode)))
                        }}
                        text={"No"}
                        buttonType="regular_primary"
                    />
                </div>
            </div>
        </div>
        </>
    )
}

export default connect(eligibilityConfirmationSelect)(EligibilityConfirmation)